var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-chart-cell"},[_c('div',{staticClass:"wrapper"},[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"data":_vm.data,"fixed-tooltip":_vm.fixedTooltip}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }